import { useOrgStore } from '@/shared/stores/orgStore';

export function useOrganization() {
  const organization = useOrgStore((s) => s.organization);
  const settings = useOrgStore((s) => s.settings);
  const featureFlags = useOrgStore((s) => s.featureFlags);

  return {
    organization,
    settings,
    featureFlags,
  };
}
